import { Component } from '@angular/core';

@Component({
	selector: 'form-optional-text, [cdxOptionalText]',
	template: ` (optional) `,
	styleUrls: ['./form-optional-text.component.scss'],
	standalone: true,
})
export class FormOptionalTextComponent {}
